import { useState as a, useEffect as c } from "react";
const r = ["cc:onConsent", "cc:onChange"], s = () => {
  var e, n;
  return !!((n = (e = window.CookieConsent) == null ? void 0 : e.acceptedCategory) != null && n.call(e, "marketing"));
};
function C() {
  const [e, n] = a(s);
  return c(() => {
    const t = () => n(s());
    return r.forEach((o) => window.addEventListener(o, t)), t(), () => {
      r.forEach((o) => window.removeEventListener(o, t));
    };
  }, []), e;
}
export {
  C as useMarketingConsent
};
//# sourceMappingURL=useMarketingConsent.js.map
